import { useRedirectToCsvImport } from '../../../hooks/useRedirectToCsvImport'
import { EditManualBankAccountModalState } from '../enums/editManualBankAccountModalState'
import { useEditManualBankAccountForm } from './useEditManualBankAccountForm'

export const useCsvAccountCreationForm = (id: string) => {
  const { redirectToCsvImport } = useRedirectToCsvImport()

  return useEditManualBankAccountForm({
    id,
    accountId: undefined,
    bankAccountId: undefined,
    state: EditManualBankAccountModalState.CreateForCsvImport,
    onSuccess: redirectToCsvImport,
  })
}
